__turbopack_context__.v({
  "message": "no-results-message-module-scss-module__kHMDtq__message",
  "message__button": "no-results-message-module-scss-module__kHMDtq__message__button",
  "message__header": "no-results-message-module-scss-module__kHMDtq__message__header",
  "message__text": "no-results-message-module-scss-module__kHMDtq__message__text",
});
